// src/pages/FaqPublicResults/components/HelpSidebar.jsx
import React from "react";

export default function HelpSidebar({
  sections,
  activeCategory,
  setActiveCategory,
  onGoToSection,
}) {
  const categories = [
    { id: "all", label: "Toutes les rubriques" },
    { id: "visitor", label: "Visiteurs" },
    { id: "organizer", label: "Organisateurs" },
    { id: "competition", label: "Gestion compétition" },
    { id: "combat", label: "Combats & score" },
    { id: "media", label: "Médias" },
  ];

  return (
    <aside className="hidden xl:block">
      <div className="sticky top-6 space-y-4">
        <section className="rounded-[28px] border border-slate-200 bg-white p-4 shadow-sm dark:border-slate-800 dark:bg-slate-900">
          <h3 className="text-sm font-bold uppercase tracking-wide text-slate-400">
            Catégories
          </h3>

          <div className="mt-3 space-y-2">
            {categories.map((item) => (
              <button
                key={item.id}
                type="button"
                onClick={() => setActiveCategory(item.id)}
                className={`w-full rounded-2xl px-3 py-2 text-left text-sm font-bold transition ${
                  activeCategory === item.id
                    ? "bg-indigo-600 text-white"
                    : "bg-slate-50 text-slate-700 hover:bg-slate-100 dark:bg-slate-950 dark:text-slate-200 dark:hover:bg-slate-800"
                }`}
              >
                {item.label}
              </button>
            ))}
          </div>
        </section>

        <section className="rounded-[28px] border border-slate-200 bg-white p-4 shadow-sm dark:border-slate-800 dark:bg-slate-900">
          <h3 className="text-sm font-bold uppercase tracking-wide text-slate-400">
            Sommaire
          </h3>

          <div className="mt-3 max-h-[55vh] space-y-2 overflow-y-auto pr-1">
            {sections.map((section) => (
              <button
                key={section.id}
                type="button"
                onClick={() => onGoToSection(section.id)}
                className="flex w-full items-start gap-2 rounded-2xl bg-slate-50 px-3 py-2 text-left text-sm font-semibold text-slate-700 transition hover:bg-indigo-50 hover:text-indigo-700 dark:bg-slate-950 dark:text-slate-200 dark:hover:bg-indigo-950/50 dark:hover:text-indigo-300"
              >
                <span>{section.icon}</span>
                <span className="line-clamp-2">{section.title}</span>
              </button>
            ))}
          </div>
        </section>
      </div>
    </aside>
  );
}